import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showMoreTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showMoreTooltip: {
		id: 'issue-field-components-readview-full.components.truncated.show-more-tooltip',
		defaultMessage: 'See more items',
		description: 'Label for trigger button to open a dialog with a list of items',
	},
});
export default messages;
